import { useBillingInterval } from "components/Signup/store/selectors/animals";
import { useWebTranslation } from "translations";
import { Color } from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import { YEARLY_BILLING_INTERVAL } from "utils/insurance";

export function BillingIntervalText({ color }: { color: Color }) {
  const { t } = useWebTranslation();
  const billingInterval = useBillingInterval();

  return (
    <Typography variant="body3" color={color}>
      {`/${
        billingInterval === YEARLY_BILLING_INTERVAL
          ? t("global.date.year")
          : t("global.date.month")
      }`}
    </Typography>
  );
}
